import { render, staticRenderFns } from "./teamType.vue?vue&type=template&id=acb73170&scoped=true"
import script from "./teamType.vue?vue&type=script&lang=js"
export * from "./teamType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb73170",
  null
  
)

export default component.exports